import { Post } from '@wellesley/openapi'

export const sortByCreatedDateDescOrder = (p1: Post, p2: Post) =>
  new Date(p2.createdAt).getTime() - new Date(p1.createdAt).getTime()

export const sortByCreatedDateAscOrder = (p1: Post, p2: Post) =>
  new Date(p1.createdAt).getTime() - new Date(p2.createdAt).getTime()
